export const Users = [
    {
      id:1,
      profilePicture: "person/1.jpeg",
      username: "Safak Kocaoglu",
      city:" New York",
      age: 23,
      hobby:"Bicycles",
      job: "Student",
      school: "Oclond high school",
      followers:[],
      followings:[]

    },
    {
      id:2,
      profilePicture: "person/2.jpeg",
      username: "Janell Shrum",
      city:"Ostin",
      age: 28,
      hobby:"Foto",
      job: "photographer",
      school: "Ostin high school",
      followers:[],
      followings:[]
    },
    {
      id:3,
      profilePicture: "person/3.jpeg",
      username: "Alex Durden",
      city:"Cape Town",
      age: 31,
      hobby:"Foto",
      job: "photographer",
      school: "Cape Town high school",
      followers:[],
      followings:[]
    },
    {
      id:4,
      profilePicture: "person/4.jpeg",
      username: "Dora Hawks",
      city:"Belogorsk",
      age: 28,
      hobby:"Web dev",
      job: "Frontend developer",
      school: "MBOU SOSH №31",
      followers:[],
      followings:[
        1, 2, 3, 5, 6, 7, 8, 9, 10
      ]
    },
    {
      id:5,
      profilePicture: "person/5.jpeg",
      username: "Thomas Holden",
      city:"Copenhagen",
      age: 31,
      hobby:"Bicycles",
      job: "Trainer",
      school: "Copenhagen high school",
      followers:[],
      followings:[]
    },
    {
      id:6,
      profilePicture: "person/6.jpeg",
      username: "Shirley Beauchamp",
      city:"Ottawa",
      age: 31,
      hobby:"Painting",
      job: "Teacher",
      school: "Copenhagen College",
      followers:[],
      followings:[]
    },
    {
      id:7,
      profilePicture: "person/7.jpeg",
      username: "Travis Bennett",
      city:"Washington",
      age: 30,
      hobby:"Backetball",
      job: "Teacher foreign language",
      school: "Washington University",
      followers:[],
      followings:[]
    },
    {
      id:8,
      profilePicture: "person/8.jpeg",
      username: "Kristen Thomas",
      city:"Rome",
      age: 30,
      hobby:"Art",
      job: "",
      school: "Rome college",
      followers:[],
      followings:[]
    },
    {
      id:9,
      profilePicture: "person/9.jpeg",
      username: "Gary Duty",
      city:"London",
      age: 37,
      hobby:"Dance",
      job: "Dance teacher",
      school: "Rome college",
      followers:[],
      followings:[]
    },
    {
      id:10,
      profilePicture: "person/10.jpeg",
      username: "Samata Dolores",
      city:"Madrid",
      age: 18,
      hobby:"",
      job: "Student",
      school: "High school",
      followers:[],
      followings:[]
    },
    {
      id:11,
      profilePicture: "person/8.jpeg",
      username: "Kristen Thomas",
      city:"Rome",
      age: 30,
      hobby:"Art",
      job: "",
      school: "Rome college",
      followers:[],
      followings:[]
    },
    {
      id:12,
      profilePicture: "person/9.jpeg",
      username: "Gary Duty",
      city:"London",
      age: 37,
      hobby:"Dance",
      job: "Dance teacher",
      school: "Rome college",
      followers:[],
      followings:[]
    },
  ];

  export const Conversations = [
    {
      id:1,
      profilePicture: "person/1.jpeg",
      username: "Safak Kocaoglu",
      message:"Heloo it's Safak ",
      you: "Hii Safak"
    },
    {
      id:2,
      profilePicture: "person/2.jpeg",
      username: "Janell Shrum",
      message:"Heloo it's Janell ",
      // you: "Hii Janell"
    },
    {
      id:3,
      profilePicture: "person/3.jpeg",
      username: "Alex Durden",
      message:"Heloo it's Alex ",
      you: "Hii Alex"
    },
    {
      id:5,
      profilePicture: "person/5.jpeg",
      username: "Thomas Holden",
      message:"Heloo it's Thomas ",
      you: "Hii Thomas"
    },
    {
      id:7,
      profilePicture: "person/7.jpeg",
      username: "Travis Bennett",
      message:"Heloo it's Travis ",
      you: "Hii Travis"
    },
    {
      id:9,
      profilePicture: "person/9.jpeg",
      username: "Gary Duty",
      message:"Heloo it's Gary ",
      you: "Hii Gary"
    },
  ];
  
  export const Posts = [
    {
      id: 1,
      desc: "Love For All, Hatred For None.",
      photo: "post/1.jpeg",
      date: "5 mins ago",
      userId: 1,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: "post/2.jpeg",
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "Every moment is a fresh beginning.",
      photo: "post/3.jpeg",
      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: "post/4.jpeg",
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    {
      id: 5,
      photo: "post/5.jpeg",
      date: "5 hours ago",
      userId: 5,
      like: 23,
      comment: 5,
    },
    {
      id: 6,
      photo: "post/6.jpeg",
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "Never regret anything that made you smile.",
      photo: "post/7.jpeg",
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: "post/8.jpeg",
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      desc: "Change the world by being yourself.",
      photo: "post/9.jpeg",
      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      photo: "post/10.jpeg",
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    },
    {
      id: 11,
      desc: "Love For All, Hatred For None.",
      photo: "post/1.jpeg",
      date: "5 mins ago",
      userId: 10,
      like: 32,
      comment: 9,
    },
    {
      id: 12,
      photo: "post/2.jpeg",
      date: "15 mins ago",
      userId: 9,
      like: 1,
      comment: 1,
    },
    {
      id: 13,
      desc: "Every moment is a fresh beginning.",
      photo: "post/3.jpeg",
      date: "1 hour ago",
      userId: 8,
      like: 61,
      comment: 2,
    },
    {
      id: 14,
      photo: "post/4.jpeg",
      date: "4 hours ago",
      userId: 7,
      like: 7,
      comment: 3,
    },
    {
      id: 15,
      photo: "post/5.jpeg",
      date: "5 hours ago",
      userId: 6,
      like: 23,
      comment: 5,
    },
    {
      id: 16,
      photo: "post/6.jpeg",
      date: "1 day ago",
      userId: 5,
      like: 44,
      comment: 6,
    },
    {
      id: 17,
      desc: "Never regret anything that made you smile.",
      photo: "post/7.jpeg",
      date: "2 days ago",
      userId: 4,
      like: 52,
      comment: 3,
    },
    {
      id: 18,
      photo: "post/8.jpeg",
      date: "3 days ago",
      userId: 3,
      like: 15,
      comment: 1,
    },
    {
      id: 19,
      desc: "Change the world by being yourself.",
      photo: "post/9.jpeg",
      date: "5 days ago",
      userId: 2,
      like: 11,
      comment: 2,
    },
    {
      id: 20,
      photo: "post/10.jpeg",
      date: "1 week ago",
      userId: 1,
      like: 104,
      comment: 12,
    },
  ];

  export const url = 'https://social-acb6snue1-grinko1.vercel.app/assets/'